import axiosRequest from "@/utils/axiosRequest";

export function list(data) {
  return axiosRequest({
    url: `/process/list`,
    data,
    method: "post"
  });
}

export function listNode(data) {
  return axiosRequest({
    url: `/process/listNode`,
    data,
    method: "post"
  });
}

export function listCommand(data) {
  return axiosRequest({
    url: `/process/listCommand`,
    data,
    method: "post"
  });
}

export function listResource(data) {
  return axiosRequest({
    url: `/process/listResource`,
    data,
    method: "post"
  });
}

export function online(data) {
  return axiosRequest({
    url: `/process/online`,
    data,
    method: "post"
  });
}

export function offline(data) {
  return axiosRequest({
    url: `/process/offline`,
    data,
    method: "post"
  });
}

